






































import Vue from "vue";
import { SystemPackage } from "../types";
import isNil from "lodash/isNil";
import { currency } from "../utils";

export default Vue.extend({
  props: {
    thePackage: {
      type: Object as () => SystemPackage
    }
  },

  computed: {
    hasRate(): boolean {
      return this.thePackage?.rate !== undefined;
    },

    isActive(): boolean {
      return this.thePackage.required || this.hasRate;
    },

    fieldBasename(): string {
      return "system_packages";
    }
  },

  methods: {
    rateToCurrency: currency,

    updateRate(rate: string | null) {
      let sanitizedRate = /\d+(\.\d{1,2})?/.exec(rate || "")?.[0];
      const { rate: _, ...packageWithoutRate } = this.thePackage;

      if (sanitizedRate === undefined || sanitizedRate === null) {
        // an invalid or empty rate has been provided
        this.$emit("input", packageWithoutRate);
        return;
      }

      // a >= $0.00 rate has been provided.
      const newRate = Number(sanitizedRate) * 100;

      if (newRate === this.thePackage.rate) {
        return; // the rate is unchanged
      }

      this.$emit("input", { ...this.thePackage, rate: newRate });
    },

    fieldName(attribute: string): string {
      return `${this.fieldBasename}[${this.thePackage.id}][${attribute}]`;
    }
  }
});
